<div
  class="ui vertical basic segment"
  style="padding: 30px"
  [ngClass]="{ loading: pendingArr?.length }"
>
  <h3 class="ui primary header">
    {{ modal.context.title }}
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </h3>
  <div
    class="content"
    style="background-color: rgba(234, 239, 251, 0.5); padding: 0px 30px"
  >
    <div class="ui divider" appMargin marginY="3"></div>
    <esl-message-toast
      [(message)]="success"
      [messageType]="success"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>

    <div class="scroll-wrapper ui basic segment">
      <div class="content">
        <div class="info">
          <label>PURPOSE/SERVICE</label>
          <p>Tender Fees</p>
        </div>
        <div class="info">
          <label>REMITA RETRIEVAL REFERENCE (RRR)</label>
          <p class="amount">{{ addedData?.transactionReference }}</p>
        </div>
        <div class="info">
          <label>AMOUNT TO PAY</label>
          <p class="amount">{{ addedData?.amount }}</p>
        </div>
        <div class="ui divider"></div>
        <div class="info">
          <label>DESCRIPTION</label>
          <p>
            {{ addedData?.additionalDetails?.description }}
          </p>
        </div>
        <div class="info">
          <label>PAYER’S ADDRESS</label>
          <p>{{ addedData?.additionalDetails?.payerAddress }}</p>
        </div>
        <div class="info">
          <label>PAYERS’S NAME</label>
          <p>{{ addedData?.additionalDetails?.payerName }}</p>
        </div>
        <div class="info">
          <label>PAYER’S PHONE</label>
          <p>{{ addedData?.additionalDetails?.payerPhone }}</p>
        </div>
        <div class="info">
          <label>PAYER’S EMAIL</label>
          <p>{{ addedData?.additionalDetails?.payerEmail }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="actions" style="margin-top: 40px">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <a href="{{ addedData?.paymentLink }}">
      <button
        class="ui primary button"
        [ngClass]="{ yellow: pendingArr?.length }"
        autofocus
      >
        Pay on Eservices
      </button>
    </a>
  </div>
</div>
